<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';
import clickOutside from '../directives/clickOutside';

export default defineComponent({
  name: 'HeaderSearch',
  directives: {
    clickOutside,
  },
  props: {
    searchApiKey: {
      type: String,
      required: true,
    },
    appId: {
      type: String,
      required: true,
    },
    environment: {
      type: String,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isEnabled: false,
      isLoading: false,
      hasInitialized: false,
      AlgoliaSearch: null as null | ReturnType<typeof defineAsyncComponent>,
    };
  },
  methods: {
    clickOutside() {
      if (this.isDesktop) {
        this.isEnabled = false;
      }
    },
    async openSearch() {
      this.isEnabled = true;
      if (this.hasInitialized || this.isLoading) return;

      this.isLoading = true;
      try {
        this.AlgoliaSearch = defineAsyncComponent(
          () => import('@vue-components/HeaderSearchAlgolia.vue'),
        );
        this.hasInitialized = true;
      } finally {
        this.isLoading = false;
      }
    },
    closeSearch() {
      this.isEnabled = false;
    },
    focusAlgoliaInput() {
      const algolia = (this.$refs as unknown as { algolia?: { focusSearchInput?: () => void } })
        .algolia;
      algolia?.focusSearchInput?.();
    },
  },
});
</script>
<template>
  <div v-click-outside.stop="clickOutside" class="relative flex items-center">
    <button aria-label="Open search bar" @click="openSearch">
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g stroke="#101820">
          <circle
            cx="8.60864"
            cy="8.93118"
            r="8.10487"
            transform="rotate(-0.0250705 8.60864 8.93118)"
          />
          <line x1="14.2891" y1="14.0332" x2="18.3867" y2="18.1307" />
        </g>
      </svg>
    </button>
    <Transition @after-enter="focusAlgoliaInput">
      <div
        v-if="isEnabled"
        class="shadow-default z-50 rounded-2xl bg-jordans-off-white focus-within:ring-2 focus-within:ring-jordans-autumn-orange lg:absolute lg:-right-3 lg:top-0 [&.v-enter-active]:transition-opacity [&.v-enter-from]:opacity-0 [&.v-leave-active]:transition-opacity [&.v-leave-to]:opacity-0"
      >
        <div v-if="isLoading || !AlgoliaSearch" class="px-4 py-3 text-sm">
          Loading search…
        </div>
        <component
          :is="AlgoliaSearch"
          v-else
          ref="algolia"
          :app-id="appId"
          :search-api-key="searchApiKey"
          :environment="environment"
          :is-desktop="isDesktop"
          @close="closeSearch"
        />
      </div>
    </Transition>
  </div>
</template>
